// Path: ./src/utils/SelectRangeDates.ts
/**
 * Selects a date range based on the button clicked.
 * @param {Date} currentDate - The current date.
 * @param {number} button - The button number clicked.  (1 to 6 only).
 *
 * 1: Returns the current date range.
 *
 * 2: Returns the date range for the  Friday to Sunday.
 *
 * 3: Returns the date range for the  Monday to Thursday.
 *
 * 4: Returns the date range for the  Thursday to Friday.
 *
 * 5: Returns the date range for the  Friday to  Thursday.
 *
 * 6: Returns the date range for the  Thursday to  Wednesday.
 * @returns {Array<Date>} - An array containing the start and end dates of the selected date range.
 */
export function selectShortCutDateRangeFn(currentDate: Date, button: number) {
  const today = currentDate.getDay();

  if (button === 1) {
    // Returns the current date range.
    return [currentDate, currentDate];
  } else if (button === 2) {
    // Returns the date range for the  Friday to Sunday.
    if (today === 6) {
      const friday = new Date(currentDate);
      friday.setDate(currentDate.getDate() - 1);
      const sunday = new Date(currentDate);
      sunday.setDate(currentDate.getDate() + 1);
      return [friday, sunday];
    } else {
      const friday = new Date(currentDate);
      friday.setDate(currentDate.getDate() + ((5 - today + 7) % 7));
      const sunday = new Date(friday);
      sunday.setDate(friday.getDate() + 2);
      return [friday, sunday];
    }
  } else if (button === 3) {
    // Returns the date range for the  Monday to Thursday.
    if (today === 0) {
      const monday = new Date(currentDate);
      monday.setDate(currentDate.getDate() + 1);
      const thursday = new Date(currentDate);
      thursday.setDate(currentDate.getDate() + 4);
      return [monday, thursday];
    } else if (today >= 1 && today <= 4) {
      const monday = new Date(currentDate);
      monday.setDate(currentDate.getDate() - (today - 1));
      const thursday = new Date(monday);
      thursday.setDate(monday.getDate() + 3);
      return [monday, thursday];
    } else {
      const monday = new Date(currentDate);
      monday.setDate(currentDate.getDate() + ((8 - today) % 7));
      const thursday = new Date(monday);
      thursday.setDate(monday.getDate() + 3);
      return [monday, thursday];
    }
  } else if (button === 4) {
    // Returns the date range for the  Thursday to Friday.
    const thursday = new Date(currentDate);
    thursday.setDate(currentDate.getDate() + ((4 - today + 7) % 7));
    const friday = new Date(thursday);
    friday.setDate(thursday.getDate() + 1);
    return [thursday, friday];
  } else if (button === 5) {
    // Returns the date range from the upcoming Friday to the following Thursday.
    const friday = new Date(currentDate);
    friday.setDate(currentDate.getDate() + ((5 - today + 7) % 7));
    const thursday = new Date(friday);
    thursday.setDate(friday.getDate() + 6);
    return [friday, thursday];
  } else if (button === 6) {
    // Returns the date range for the  Thursday to  Wednesday.
    const thursday = new Date(currentDate);
    thursday.setDate(currentDate.getDate() + ((4 - today + 7) % 7));
    const wednesday = new Date(thursday);
    wednesday.setDate(thursday.getDate() + 6);
    return [thursday, wednesday];
  }
}
